"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("es6-symbol/implement"); //ponyfills Symbol for IE. Observe uses Symbol
const observe_1 = __importDefault(require("observe"));
const window_or_global_1 = __importDefault(require("window-or-global"));
if (!window_or_global_1.default._epicGamesNavObserverCallbacks) {
    window_or_global_1.default._epicGamesNavObserverCallbacks = [];
}
/**
 * Set the defaults for the config.
 */
const defaultConfig = {
    //whether the user is logged in or not. controls the signon dropdown
    isLoggedIn: false,
    //sets the main links in the navigation
    links: [],
    //hides the locale dropdown
    hideLocale: true,
    //hides the search
    hideSearch: true,
    //hides the sign in and username dropdown
    hideSignIn: true,
    hideCallToAction: true,
    ctaMobilePosition: "rightNav",
    //customize the call to action
    callToAction: {},
    //currently selected locale. should match a lang in the localeOptions
    locale: "en-US",
    //user's gamertag if logged in
    displayName: "Account",
    //items in the locale dropdown
    localeOptions: [],
    //controls the anchor tag of the property logo
    logoLink: {},
    //account related links
    accountLinks: {
        //shows dropdown for sign in options if array length > 1
        signInLinks: [],
        //sign out link
        signOutLink: {},
        //links which will go in the logged in dropdown menu
        dropdownLinks: [],
    },
};
//Loop over the epicGamesNav object and plug in any missing keys from the defaultConfig
if (!window_or_global_1.default._epicGamesNav) {
    window_or_global_1.default._epicGamesNav = defaultConfig;
}
else {
    const missingAssumeFalsey = ["hideLocale", "hideSearch", "hideSignIn", "hideCallToAction"];
    if (typeof window_or_global_1.default._epicGamesNav === "object") {
        for (const key in defaultConfig) {
            if (key && typeof key === "string") {
                if (!Object.prototype.hasOwnProperty.call(window_or_global_1.default._epicGamesNav, key) && missingAssumeFalsey.indexOf(key) === -1) {
                    window_or_global_1.default._epicGamesNav[key] = defaultConfig[key];
                }
            }
        }
    }
}
window_or_global_1.default._epicGamesNavObserver = (0, observe_1.default)(window_or_global_1.default._epicGamesNav);
window_or_global_1.default._epicGamesNavObserver.on("change", (change) => {
    if (typeof window_or_global_1.default._epicGamesNav === "object" &&
        window_or_global_1.default._epicGamesNavObserverCallbacks &&
        window_or_global_1.default._epicGamesNavObserverCallbacks.length) {
        for (let i = 0; i < window_or_global_1.default._epicGamesNavObserverCallbacks.length; i++) {
            const callback = window_or_global_1.default._epicGamesNavObserverCallbacks[i];
            if (callback && typeof callback === "function") {
                callback(change);
            }
        }
    }
});
window_or_global_1.default._epicGamesNavObserverCreated = true;
const addObserverCallback = (fn) => {
    if (typeof fn === "function") {
        window_or_global_1.default._epicGamesNavObserverCallbacks.push(fn);
    }
};
exports.default = addObserverCallback;
//# sourceMappingURL=epicGamesNavObserver.js.map